import { TooltipsInterface } from "../interfaces/nt-tooltips";

export const TOOLTIPS_NT: TooltipsInterface[] = [
    {
      id: 0,
      className: 'widget-esperienze-map',
      text: 'Esperienze potenziali per singola Regione',
    },
    {
      id: 1,
      className: 'widget-heatmap',
      text: "Rappresentazione visiva dell'apertura regionale, comprensiva del dettaglio della possibilità di acquisto a livello Ospedaliero",
    },
    {
      id: 2,
      className: 'widget-attivita',
      text: 'Aggregazione di livello Nazionale di tutte le attività e tattiche inserite nei piano di Accesso Regionali e Locali',
    },
    {
      id: 3,
      className: 'widget-curva-accesso',
      text: 'Accesso puro a livello Regionale, ovvero inserimento in prontuario Regionale o delibera di livello Regionale o delibera dei centri prescrittori',
    },
    {
      id: 4,
      className: 'widget-curva-mercato',
      text: 'Apertura a livello Ospedaliero, ovvero inserimento a livello Locale con concreta e materiale apertura a livello di Centro',
    },
    {
      id: 5,
      className: 'widget-mapOpenAccess',
      text: "Rappresentazione visiva dell'inclusione a livello regionale, senza la concreta apertura a livello Ospedaliero",
    },
    {
      id: 6,
      className: 'widget-evolution-regional-access',
      text: 'Accesso a livello delle singole Regioni nel corso del tempo, senza il dettaglio di apertura a livello Ospedaliero',
    },
    {
      id: 7,
      className: 'widget-monitoringForecastVsActualRegionalLevel',
      text: 'Confronto temporale, in termini di mesi, tra Forecast (stime) e Actual (esiti) a livello di Accesso Regionale',
    },
    {
      id: 8,
      className: 'widget-forecastTimeProgress',
      text: 'Progresso temporale, con una comparazione in giorni tra la data di Forecast (stime) in Accesso Regionale e la data odierna',
    },
    {
      id: 9,
      className: 'widget-nHospitalsAndExperiences',
      text: 'Esperienze potenziali a livello nazionale e numero totale di Ospedali sul territorio',
    },
    {
      id: 10,
      className: 'widget-evolution-regional-market',
      text: 'Accesso a livello dei singoli Centri Ospedalieri nel corso del tempo',
    },
    {
      id: 11,
      className: 'widget-map-forecast-complete-access',
      text: "Tempistica di Forecast (stime) tra GU e l'accesso completo in tutti i Centri Ospedalieri della Regione",
    },
    {
      id: 12,
      className: 'widget-monitoringCompleteAccess',
      text: 'Confronto temporale, in termini di mesi, tra Forecast (stime) e Actual (esiti) a livello di accesso completo in Regione inteso come almeno il 95% di apertura ospedaliera',
    },
    {
      id: 13,
      className: 'widget-monitoringAggiudicazione',
      text: 'Confronto temporale, in termini di mesi, tra Forecast (stime) e Actual (esiti) a livello di aggiudicazione della gara regionale',
    },
        {
      id: 14,
      className: 'widget-inclusion-process-tool-national',
      text: 'Prospettiva aggregata nazionale degli step fondamentali, dei processi di inclusione, delle Regioni Italiane',
    },
            {
      id: 15,
      className: 'widget-heatmap-economia',
      text: "Rappresentazione visiva dell'apertura regionale, focalizzata sul dettaglio della possibilità di acquisto in economia a livello Ospedaliero",
    },
    {
      id: 16, 
      className: 'widget-curva-economia',
      text: "Apertura in Economia, ovvero per acquisti sotto soglia con affidamento diretto o procedura negoziata",
    },
        {
      id: 17, 
      className: 'widget-forecast-accuracy-openToAccess',
      text: "Accuratezza previsionale, misurata come il differenziale tra Actual e Forecast in Inclusione regionale",
    },
     {
      id: 18, 
      className: 'widget-forecast-accuracy-openToEconomia',
      text: "Accuratezza previsionale, misurata come il differenziale tra Actual e Forecast in Apertura in Economia",
    },
    {
      id: 19,
      className: 'widget-forecast-accuracy-openToMarket',
      text: "Accuratezza previsionale, misurata come il differenziale tra Actual e Forecast in Apertura al Mercato",
    },
    {
      id: 20,
      className: 'widget-evolution-regional-economia',
      text: "Accesso in Economia, ovvero per acquisti sotto soglia con affidamento diretto o procedura negoziata, nel corso del tempo",
    },
        {
      id: 21,
      className: 'widget-open-to-market-curve-30-days',
      text: "Apertura a livello Ospedaliero, ovvero inserimento a livello Locale con concreta e materiale apertura a livello di Centro",
    },
            {
      id: 22,
     className: 'widget-evolution-regional-market-30-days',
      text: 'Accesso a livello dei singoli Centri Ospedalieri nel corso del tempo',
    },

  ];

